export const navigation = ['All', 'Favorite', 'Top'];
